import { QuizzesItemType } from '../types';
import { uniqueIdFactory } from './uniqueIds';

export type ItemWithParent = {
  parentId: number;
  type: QuizzesItemType;
  id: number;
};

/**
 * This finds all children of the passed in ID.
 */
export const findAllChildren = ({
  items,
  currentId,
}: {
  items: ItemWithParent[];
  currentId: number;
}) =>
  items
    .filter((item) => item.parentId === currentId)
    .map(({ id, type }) => uniqueIdFactory[type].toUniqueId(id));
